import React from 'react';
import './FilterPill.css';

const FilterPill = ({ icon, name, isActive, onClick }) => {
    return (
        <div
            className={`filter-pill ${isActive ? 'active' : ''}`}
            onClick={onClick}
        >
            <span className="pill-icon">{icon}</span>
            <span className="pill-name">{name}</span>
        </div>
    );
};

export default FilterPill;
